<template>
  <v-dialog
    persistent
    v-model="dialog"
    @keydown.esc="dialog = false"
    width="850"
    scrollable
  >
    <v-form ref="form" @submit.prevent lazy-validation v-model="valid">
      <v-card class="elevation-3">
        <v-card-title class="primary text-h5 white--text">
          {{ modalText }}
        </v-card-title>
        <v-card-text class="pa-4">
          <!-- <v-row>
            <v-col sm="12">
              <v-text-field 
                label="Tracked Bill ID" 
                v-model="selectedTrackedBillUser.TrackedBillID"
                type="number"
                :rules="[v => !!v || 'required']"
              ></v-text-field>
            </v-col>
          </v-row> -->
          <v-row>
            <v-col sm="12">
              <User
                label="User"
                v-model="selectedTrackedBillUser.UserID"
                :rules="[(v) => !!v || 'required']"
              >
                <template v-slot:item="{ item, index }">
                  <span v-if="item.FirstName && item.LastName">
                    {{ item.FirstName }} {{ item.LastName }} - ({{
                      item.Email
                    }})
                  </span>
                  <span v-else>{{ item.Email }}</span></template
                >
                <template v-slot:selection="{ item, index }">
                  <span v-if="item.FirstName && item.LastName">
                    {{ item.FirstName }} {{ item.LastName }}
                  </span>
                  <span v-else>{{ item.Email }}</span></template
                >
              </User>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="12">
              <LuTrackedBillPermission
                label="Permission"
                v-model="selectedTrackedBillUser.TrackedBillPermissionID"
                :currentUserPermissionID="currentUserPermissionID"
                :rules="[(v) => !!v || 'required']"
              ></LuTrackedBillPermission>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn
            @click="saveTrackedBillUserDetails"
            :disabled="saving"
            color="primary"
            >Save</v-btn
          >
          <v-btn outlined color="primary" @click="cancelEntry">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import { get, sync, commit, call } from 'vuex-pathify'
import TrackedBillUser from '@classes/TrackedBillUser'
import User from '@components/select/a-single/User'
import LuTrackedBillPermission from '@components/select/single/LuTrackedBillPermission'
//templateTODO: import lookup components you plan to use
export default {
  components: { User, LuTrackedBillPermission },
  data: () => ({
    dialog: false,
    valid: true,
    selectedTrackedBillUser: new TrackedBillUser(),
    modalText: '',
  }),
  props: {
    trackedBillID: {
      type: Number,
      required: true,
    },
    currentUserPermissionID: {
      type: Number,
      required: true,
    },
  },
  created() {},
  computed: {
    ...get('trackedBillUser', ['saving']),
  },
  methods: {
    handleError: call('errors/handleError'),
    ...call('trackedBillUser', ['saveTrackedBillUser']),
    async validate() {
      this.$refs.form.validate()
    },
    editTrackedBillUser(entry) {
      this.selectedTrackedBillUser = new TrackedBillUser(entry)
      this.modalText = 'Edit User Permissions'
      this.dialog = !this.dialog
    },
    addTrackedBillUser() {
      this.modalText = 'Add User Permissions'
      this.selectedTrackedBillUser = new TrackedBillUser()
      this.selectedTrackedBillUser.TrackedBillID = this.trackedBillID
      this.dialog = !this.dialog
    },
    saveTrackedBillUserDetails() {
      this.validate().then(() => {
        if (this.valid) {
          //templateTODO: if you want to save related item arrays you will need to add a getSaveData() function to the javascript class and call that instead
          this.saveTrackedBillUser(
            this.selectedTrackedBillUser.removeRelated()
          ).then(
            (res) => {
              this.$emit('refresh')
              this.selectedTrackedBillUser = new TrackedBillUser()
              this.$refs.form.resetValidation()
            },
            (err) => {}
          )
          this.dialog = false
        }
      })
    },
    cancelEntry() {
      this.dialog = false
      this.selectedTrackedBillUser = new TrackedBillUser()
      this.$refs.form.resetValidation()
    },
  },
}
</script>
<style></style>
